import { schema } from 'normalizr'; // --------- GET DATA FOR ORGANIZATIONS --------- //

export var organization = new schema.Entity('organizations', {}, {
  idAttribute: function idAttribute(_ref) {
    var id = _ref.id;
    return parseInt(id, 10);
  },
  processStrategy: function processStrategy(_ref2) {
    var id = _ref2.id,
        financeId = _ref2.financeId,
        name = _ref2.name,
        nameG = _ref2.nameG,
        slug = _ref2.slug,
        license = _ref2.license,
        vendorLink = _ref2.vendorLink,
        ratingStability = _ref2.ratingStability,
        popular = _ref2.popular,
        logo = _ref2.logo,
        logoSquare1x = _ref2.logoSquare1x,
        fullLogo = _ref2.fullLogo,
        menu = _ref2.menu,
        backgroundImage = _ref2.backgroundImage,
        rkoCommercialOrderMinfin = _ref2.rkoCommercialOrderMinfin;
    return {
      id: parseInt(financeId, 10) || 0,
      minfinId: parseInt(id, 10) || 0,
      slug: slug.toLowerCase(),
      ratingStability: Number(ratingStability),
      name: name,
      nameG: nameG,
      license: license,
      popular: popular,
      vendorLink: vendorLink,
      logo: logo,
      logoSquare1x: logoSquare1x,
      fullLogo: fullLogo,
      menu: menu,
      backgroundImage: backgroundImage,
      rkoCommercialOrderMinfin: rkoCommercialOrderMinfin || 0
    };
  }
});
export var organizations = [organization];